declare const __DEV__: boolean;
declare const process: { env: { API_URL?: string } };

export const config = {
  apiUrl: process.env.API_URL || 'http://localhost:3000/api',
  isDev: __DEV__,
} as const;

export type AppConfig = typeof config;
